export const tickets = [
  {
    id: "1",
    title: "Ticket Title",
    type: "Ticket Type",
    startDate: "4-5-2022",
    endDate: "4-7-2022",
    description:
      "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque",
    comments: [
      {
        id: 1,
        author: "Commenter Name",
        date: "4-5-2022",
        comment:
          "commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus ",
        authorImage: "/img/avatars/thumb-3.jpg",
      },
    ],
  },
  {
    id: "2",
    title: "Ticket Title 2",
    type: "Ticket Type",
    startDate: "4-5-2022",
    endDate: "4-7-2022",
    description:
      "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque",

    comments: [
      {
        id: 1,
        author: "Commenter1 Name",
        date: "4-5-2022",
        comment:
          "commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus ",
        authorImage: "/img/avatars/thumb-1.jpg",
      },
    ],
  },
  {
    id: "2",
    title: "Ticket Title 3",
    type: "Ticket Type",
    startDate: "4-5-2022",
    endDate: "4-7-2022",
    description:
      "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque",

    comments: [
      {
        id: 1,
        author: "Commenter2 Name",
        date: "4-5-2022",
        comment:
          "commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus ",
        authorImage: "/img/avatars/thumb-2.jpg",
      },
    ],
  },
];
